import GameStorage from './GameStorage';
import Game from './scenes/Game';
import TitleScreenBase from './scenes/TitleScreenBase';

export const GameVersions = {
  OddOrEven: 'odd',
  Factors: 'factors',
  Multiples: 'multiples',
};

export default {
  // this is set in main because the 3 games have slightly different Game scenes
  scenes: [],

  // all 3 games share the same base title screen which uses the same key
  startScene: TitleScreenBase.KEY,

  /** @type {GameStorage} */
  gameStorage: null,
  bestScore: 0,
  gameMode: null, // For Odd or Even: can be "Odd" or "Even"; for Multiples, will be one of the numbers; for Factors, "Factors"
  gameVersion: GameVersions.OddOrEven, // odd, multiples, factors,
  fontColor: 0xffffff, // Factors changes this to 0x5c4939
  MAX_NUM_VALUE: 20, // 20 for odd or even, 100 for factors, 240 for multiples
  PLAY_BUTTONS: [], // the buttons needed for Factors and Odd or Even
  LEVEL_TIME: 60
};

export const GAME_IMAGES_KEY = 'gameuiassets';
export const GAME_IMAGES_JSON_PATH = 'assets/images/GameUIAssets.json';
export const GAME_IMAGE_BASE_PATH = 'assets/images/';
export const SPARKLE_ANIMATION_KEY = 'sparkleanimation';
export const SPARKLE_ANIMATION_PATH = 'assets/images/sparkle_21x23.png';

export const ODD_GAME_MODE = 'Odd';
export const EVEN_GAME_MODE = 'Even';
export const FACTORS_GAME_MODE = 'Factors';